import React from 'react';
import T from 'prop-types';

import {
  Menu,
  MenuItem,
  MenuButton,
  useMenuProps,
} from '../../../../components/DropdownSet';
import Tooltip from '../../../../components/Tooltip';

const ActionsDropdown = ({
  item,
  size,
  isDuplicateDisabled,
  isDeleteDisabled,
  onEdit,
  onRename,
  onDuplicate,
  onDelete,
}) => {
  const menuProps = useMenuProps({
    align: 'end',
    overflow: 'visible',
    viewScroll: 'close',
    menuStyle: { width: 136 },
    className: 'actions-dropdown-menu',
  });

  return (
    <div className="actions-dropdown-container">
      <Menu
        menuButton={(
          <MenuButton
            size={size}
            shape="square"
            caret={false}
            variant="light"
          >
            <Tooltip
              id="update-tooltip"
              content="Update"
              placement="topRight"
            >
              <i className="hicon-more-vert" />
            </Tooltip>
          </MenuButton>
        )}
        {...menuProps}
      >
        {onEdit && (
          <MenuItem onClick={() => onEdit(item)}>
            <i className="hicon-edit-2" />
            Edit
          </MenuItem>
        )}
        <MenuItem onClick={() => onRename(item)}>
          <i className="hicon-rename" />
          Rename
        </MenuItem>
        <MenuItem
          disabled={isDuplicateDisabled}
          onClick={() => !isDuplicateDisabled && onDuplicate(item)}
        >
          <i className="hicon-duplicate" />
          Duplicate
        </MenuItem>
        <MenuItem
          disabled={isDeleteDisabled}
          className={isDeleteDisabled ? '' : 'text-rose'}
          onClick={() => !isDeleteDisabled && onDelete(item)}
        >
          <i className="hicon-remove" />
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

ActionsDropdown.propTypes = {
  item: T.object.isRequired,
  size: T.oneOf(['sm']),
  isDuplicateDisabled: T.bool,
  isDeleteDisabled: T.bool,
  onEdit: T.func,
  onRename: T.func.isRequired,
  onDuplicate: T.func.isRequired,
  onDelete: T.func.isRequired,
};

export default ActionsDropdown;
